<template>
    <app-layout>
        <Head>
            <title>Anfrage einstellen</title>
        </Head>

        <template v-slot:overline>
            <translate>Anfrage einstellen</translate>
        </template>

        <template v-slot:headline>{{ this.$page.props.user.name }}</template>

        <template v-slot:stepper>
            <stepper>
                <step icon="list-basket-checkmark" class-names="active" routing="ask-for-quote.1">
                    <translate>Bauteilinformationen</translate>
                </step>
                <step icon="delivery-shipment-packages-setting" class-names="active">
                    <translate>Lieferung</translate>
                </step>
                <step icon="credit-card-security-protection">
                    <translate>Anfrage senden</translate>
                </step>
            </stepper>
        </template>

        <div class="ask-for-quote">
            <card>
                <card-content>
                    <h5 v-translate>Für ein Angebot Ihrer Fertigungsanfrage,<br/>benötigen wir eine Lieferadresse.</h5>
                    <form @submit.prevent="submit">
                        <div class="ask-for-quote--grid">
                            <div class="ask-for-quote--left">
                                <form-select id="client_address_id" :label="this.$gettext('Lieferaddresse')"
                                             v-model="form.client_address_id" :options="clientAddressesOptions"
                                             v-if="clientAddressesOptions" @change="clientAddressesSelect"/>
                                <form-input type="text" id="name" :label="this.$gettext('Name')" v-model="form.name"
                                            :error="form.errors.name" autocomplete="name"/>
                                <form-input type="text" id="company" :label="this.$gettext('Firma')" v-model="form.company"
                                            :error="form.errors.company" autocomplete="organization"/>
                                <form-input type="text" id="vat_id" :label="this.$gettext('UST-ID')" v-model="form.vat_id"
                                            :error="form.errors.vat_id" autocomplete="vat_id" v-if="noVatId"/>
                                <input type="hidden" name="vat_id" v-model="form.vat_id" v-if="!noVatId"/>
                            </div>
                            <div class="ask-for-quote--right">
                                <form-group>
                                    <form-input type="text" id="street" :label="this.$gettext('Straße')" v-model="form.street"
                                                :error="form.errors.street" class="three-four"
                                                autocomplete="street-address"/>
                                    <form-input type="text" id="street_no" :label="this.$gettext('Nr')" v-model="form.street_no"
                                                :error="form.errors.street_no" class="one-four"/>
                                </form-group>

                                <form-group>
                                    <form-input type="text" id="zip" :label="this.$gettext('Plz')" v-model="form.zip"
                                                :error="form.errors.zip" class="one-four" autocomplete="postal-code"/>
                                    <form-input type="text" id="city" :label="this.$gettext('Ort')" v-model="form.city"
                                                :error="form.errors.city" class="three-four"
                                                autocomplete="address-level2"/>
                                </form-group>

                                <form-select id="client_country_id" :label="this.$gettext('Land')" :options="clientCountries"
                                             v-model="form.client_country_id"
                                             :error="form.errors.client_country_id"/>

                                <form-input type="text" id="phone" :label="this.$gettext('Telefon (optional)')" v-model="form.phone"
                                            :error="form.errors.phone" autocomplete="tel" />

                                <form-checkbox id="store_client_address" v-model:checked="form.store_client_address"
                                               :error="form.errors.store_client_address"
                                               :option="this.$gettext('neue Lieferadresse im Adressbuch speichern')"
                                               v-if="newAddressButton"/>

                                <div class="form-actions">
                                    <form-button type="button" icon="button-arrow-left-circle" @click="back()"
                                                 iconBefore="1">
                                        <translate>zurück</translate>
                                    </form-button>
                                    <form-button type="submit" color="secondary" icon="button-arrow-right-circle" :disabled="form.processing" :class="{'btn--processing': form.processing}">
                                        <translate>weiter zum nächsten Schritt</translate>
                                    </form-button>
                                </div>
                            </div>
                        </div>
                    </form>
                </card-content>
            </card>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import {useForm} from '@inertiajs/vue3';
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormButton from '@partfactory/Shared/Form/FormButton';
import Step from '@partfactory/Shared/Stepper/Step';
import Stepper from '@partfactory/Shared/Stepper/Stepper';
import FormGroup from '@partfactory/Shared/Form/FormGroup';
import FormSelect from '@partfactory/Shared/Form/FormSelect';
import FormCheckbox from '@partfactory/Shared/Form/FormCheckbox';

export default {
    name: 'AskForQuote.2',
    components: {
        FormCheckbox,
        FormSelect,
        FormGroup,
        Stepper,
        Step,
        FormButton,
        FormInput,
        CardContent,
        Card,
        AppLayout,
    },
    props: {
        askForQuoteAddress: Object,
        clientAddresses: Object,
        clientCountries: Object,
    },
    data() {

        const clientAddress = this.clientAddresses.length > 1 ? this.clientAddresses.filter(clientAddress => {
            return clientAddress.default_address === true;
        }) : this.clientAddresses;

        const form = useForm({
            client_address_id: this?.askForQuoteAddress ? null : clientAddress[0]?.id,
            name: this?.askForQuoteAddress?.name ? this?.askForQuoteAddress?.name : clientAddress[0]?.name,
            company: this?.askForQuoteAddress?.company ? this?.askForQuoteAddress?.company : clientAddress[0]?.company,
            street: this?.askForQuoteAddress?.street ? this?.askForQuoteAddress?.street : clientAddress[0]?.street,
            street_no: this?.askForQuoteAddress?.street_no ? this?.askForQuoteAddress?.street_no : clientAddress[0]?.street_no,
            zip: this?.askForQuoteAddress?.zip ? this?.askForQuoteAddress?.zip : clientAddress[0]?.zip,
            city: this?.askForQuoteAddress?.city ? this?.askForQuoteAddress?.city : clientAddress[0]?.city,
            client_country_id: this?.askForQuoteAddress?.client_country_id ? this?.askForQuoteAddress?.client_country_id : clientAddress[0]?.client_country_id,
            phone: this?.askForQuoteAddress?.phone ? this?.askForQuoteAddress?.phone : clientAddress[0]?.phone,
            store_client_address: this?.askForQuoteAddress?.store_client_address,
            vat_id: this?.askForQuoteAddress?.vat_id ? this?.askForQuoteAddress?.vat_id : this.$page.props.user.vat_id,
        });

        return {form};
    },
    computed: {
        clientAddressesOptions() {

            const clientAddresses = this.clientAddresses.filter(clientAddress => {
                return clientAddress.company !== null && clientAddress.street !== null && clientAddress.street_no !== null && clientAddress.zip !== null && clientAddress.city !== null;
            });

            if (clientAddresses.length > 0) {
                return this.clientAddresses?.map(clientAddress => {
                    return {
                        value: clientAddress.id,
                        text: clientAddress.company + ', ' + clientAddress.street + ' ' + clientAddress.street_no + ', ' + clientAddress.zip + ' ' + clientAddress.city
                    };
                });
            }
            return null;
        },
        newAddressButton() {
            return this.clientAddresses.length < 6;
        },
        noVatId() {
            return !this.$page.props.user.vat_id;
        }
    },
    methods: {
        clientAddressesSelect() {
            const clientAddress = this.clientAddresses.filter(clientAddress => {
                return clientAddress.id === Number(this.form.client_address_id);
            });

            this.form.client_address_id = clientAddress[0].id;
            this.form.name = clientAddress[0].name;
            this.form.company = clientAddress[0].company;
            this.form.street = clientAddress[0].street;
            this.form.street_no = clientAddress[0].street_no;
            this.form.zip = clientAddress[0].zip;
            this.form.city = clientAddress[0].city;
            this.form.client_country_id = clientAddress[0].client_country_id;
            this.form.phone = clientAddress[0].phone;
        },
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    store_client_address: this.form.store_client_address ? 'true' : '',
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('ask-for-quote.2.post'), {
                    onSuccess: () => {
                        // Anfrage-Formular abgeschickt (Schritt 2)
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'form_send',
                            'formName': 'Anfrage',
                            'formStep': '2 - Anfrage einstellen, Lieferadresse',
                            'formLang': this.$language.current,
                        });
                    }
                });
        },
        back() {
            this.$inertia.visit(this.$$route('ask-for-quote.1'));
        }
    }
};
</script>
